import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Oracle from "@/components/Oracle";
import AdminOneLayout from "@/components/adminone/AdminOneLayout";
import AdminOneLogin from "@/components/adminone/AdminOneLogin";
import AdminOneDashboard from "@/components/adminone/AdminOneDashboard";
import AdminOracleFeed from "@/components/adminone/AdminOracleFeed";
import AdminOandaCenter from "@/components/adminone/AdminOandaCenter";
import AdminReports from "@/components/adminone/AdminReports";
import AdminCompliance from "@/components/adminone/AdminCompliance";
import AdminAudit from "@/components/adminone/AdminAudit";
import AdminUsers from "@/components/adminone/AdminUsers";
import AdminSessions from "@/components/adminone/AdminSessions";
import AdminSettings from "@/components/adminone/AdminSettings";
import AdminSignals from "@/components/adminone/AdminSignals";
import AdminWatchtowers from "@/components/adminone/AdminWatchtowers";
import AdminOps from "@/components/adminone/AdminOps";
import AdminServiceIntelligence from "@/components/adminone/AdminServiceIntelligence";
import AdminHealthcareMap from "@/components/adminone/AdminHealthcareMap";
import AdminMembership from "@/components/adminone/AdminMembership";
import AdminMembershipAnalytics from "@/components/adminone/AdminMembershipAnalytics";
import AdminTelemetry from "@/components/adminone/AdminTelemetry";
import AdminRateLimits from "@/components/adminone/AdminRateLimits";
import AdminOrgs from "@/components/adminone/AdminOrgs";
import AdminIngestion from "@/components/adminone/AdminIngestion";
import AdminLogix2 from "@/components/adminone/AdminLogix2";
import AdminOpportunityRadar from "@/components/adminone/AdminOpportunityRadar";
import AdminDiagnostics from "@/components/adminone/AdminDiagnostics";
import AdminChyronManager from "@/components/adminone/AdminChyronManager";
import AdminAfricaWatchtower from "@/components/adminone/AdminAfricaWatchtower";
import AdminGlobalAIWatchtower from "@/components/adminone/AdminGlobalAIWatchtower";
import UgandaPhase2ActivationCommand from "@/components/adminone/UgandaPhase2ActivationCommand";
import AdminOracleIntelligenceDashboard from "@/components/adminone/AdminOracleIntelligenceDashboard";
import AdminStartupsGrants from "@/components/adminone/AdminStartupsGrants";
import AdminBriefingCenter from "@/components/adminone/AdminBriefingCenter";
import OracleWatchtowers from "@/components/adminone/OracleWatchtowers";
import OracleSignalCommand from "@/components/adminone/OracleSignalCommand";
import AdminScannerCommand from "@/components/adminone/AdminScannerCommand";
import AdminNotificationFabric from "@/components/adminone/AdminNotificationFabric";
import AdminProtectedRoute from "@/components/adminone/AdminProtectedRoute";
import { MembershipProvider } from "@/components/membership/MembershipContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { AnimationSettingsProvider } from "@/components/animation/AnimationSettings";
import { PersonalizationProvider } from "@/components/personalization/PersonalizationContext";
import AccessLogin from "@/pages/AccessLogin";
import AuthCallback from "@/pages/AuthCallback";
// Phase 32.2 — CareLogix Constitutional Gate Orchestrator (3-gate sequence: Privacy → ORACLE Risk V3 → Membership)
import ConstitutionalGateOrchestrator from "@/components/gate/ConstitutionalGateOrchestrator";
// Phase 33 — Predictive Command + Funding Command + AdminOne Phase 33 surfaces
import OraclePredictiveCommand from "@/components/predictive/OraclePredictiveCommand";
import OracleFundingCommand from "@/components/funding/OracleFundingCommand";
import OracleGlobalCapitalCommand from "@/components/capital/OracleGlobalCapitalCommand";
import AdminFundingIntelligence from "@/components/adminone/AdminFundingIntelligence";
import AdminMarketAbuseAwareness from "@/components/adminone/AdminMarketAbuseAwareness";
import AdminSystemArchitecture from "@/components/adminone/AdminSystemArchitecture";
// CLX Hardening OS v1 (ORACLE-faithful, additive) — AdminOne Enterprise Telemetry page
import AdminOneEnterpriseTelemetry from "@/pages/admin/AdminOneEnterpriseTelemetry";
import AdminOneExecutiveIntelligence from "@/pages/admin/AdminOneExecutiveIntelligence";
import AdminOneCEOTravelCommand from "@/pages/admin/AdminOneCEOTravelCommand";
// CareLogix™ Global Integration Connector Pack v1 (AdminOne only)
import AdminOneConnectorStatusPage   from "@/pages/adminone/AdminOneConnectorStatusPage";
import AdminOneEHRIngestionPage      from "@/pages/adminone/AdminOneEHRIngestionPage";
import AdminOneAfricaHealthNodesPage from "@/pages/adminone/AdminOneAfricaHealthNodesPage";
import AdminOneMobilityDispatchPage  from "@/pages/adminone/AdminOneMobilityDispatchPage";
import AdminOnePayoutLedgerPage      from "@/pages/adminone/AdminOnePayoutLedgerPage";
import AdminOneFoodRxIntelligence    from "@/pages/adminone/AdminOneFoodRxIntelligence";
import OracleFoodRxPage              from "@/pages/oracle/OracleFoodRxPage";
import OracleLifeCommand from "@/pages/lifecommand/OracleLifeCommand";
// Final Daily Habit Intelligence Build Pack — additive
import OracleLifeScorePage   from "@/pages/oracle/OracleLifeScorePage";
import OracleWearablesPage   from "@/pages/oracle/OracleWearablesPage";
import OracleAnimationsPage  from "@/pages/oracle/OracleAnimationsPage";
import AdminOneLifeCommand   from "@/pages/adminone/AdminOneLifeCommand";
// AdminOne CEO Membership Control™ — additive
import AdminOneMembershipDashboard from "@/pages/adminone/AdminOneMembershipDashboard";
// ORACLE Live Data Control Center™ — additive (Live Data Enforcement Fix Pack)
import AdminOneLiveDataCenter from "@/pages/adminone/AdminOneLiveDataCenter";
import AdminOneLiveLLMEngine from "@/pages/adminone/AdminOneLiveLLMEngine";
import AdminOneContentGenerator from "@/pages/adminone/AdminOneContentGenerator";
import AdminOneInboxPage from "@/pages/adminone/AdminOneInboxPage";
import AdminOneCoreSatellitePage from "@/pages/adminone/AdminOneCoreSatellitePage";
import OracleCoreSatellitePage from "@/pages/oracle/OracleCoreSatellitePage";
import OracleHomePage from "@/pages/oracle/OracleHomePage";
import OracleBriefingCenterPage from "@/pages/oracle/OracleBriefingCenterPage";
import AdminOneCEODashboardPage from "@/pages/adminone/AdminOneCEODashboardPage";
import OracleAIBusinessPage from "@/pages/oracle/OracleAIBusinessPage";
import AdminOneAIBusinessCommandPage from "@/pages/adminone/AdminOneAIBusinessCommandPage";
import OraclePlatformMapPage from "@/pages/oracle/OraclePlatformMapPage";
import AdminOneSystemReadinessPage from "@/pages/adminone/AdminOneSystemReadinessPage";
import AdminOneLogix2HealthPage from "@/pages/adminone/AdminOneLogix2HealthPage";
// Phase 36 — Global Intelligence Globe (3D default with 2D fallback, additive)
import IntelligenceGlobe from "@/pages/intelligence-globe/index.jsx";
// AdminOne data-leak hardening — global fetch guard
import { installAdminOneApiGuard } from "@/api/adminOneApiGuard";

// Install the guard immediately at module load so any subsequent fetch goes through it.
installAdminOneApiGuard();


// Synchronous OAuth-callback detector (per Emergent Auth playbook).
// If the URL fragment contains `session_id=`, render <AuthCallback /> BEFORE
// any other route resolution — this prevents race conditions with the
// AuthProvider's /me check.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public ORACLE app at the root — Phase 32.2 Constitutional 3-gate sequence wraps it */}
      {/* Simplicity Release v2.0 — clean public homepage. The dense legacy
          Oracle dashboard stays available at /oracle/dashboard (additive,
          no deletions). */}
      <Route path="/"                element={<ConstitutionalGateOrchestrator><OracleHomePage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/dashboard" element={<ConstitutionalGateOrchestrator><Oracle /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/platform-map" element={<ConstitutionalGateOrchestrator scope="oracle"><OraclePlatformMapPage /></ConstitutionalGateOrchestrator>} />

      {/* Phase 33 — ORACLE PREDICTIVE COMMAND™ (gated by the same constitutional sequence) */}
      <Route path="/oracle/predictive" element={<ConstitutionalGateOrchestrator><OraclePredictiveCommand /></ConstitutionalGateOrchestrator>} />
      {/* Phase 38 — Core-Satellite Intelligence™ (public page; gated by constitutional gate) */}
      <Route path="/oracle/core-satellite" element={<ConstitutionalGateOrchestrator scope="oracle"><OracleCoreSatellitePage /></ConstitutionalGateOrchestrator>} />
      {/* Phase 33 — ORACLE FUNDING COMMAND™ */}

      {/* CLX Hardening OS v1 — AdminOne Enterprise Telemetry (additive only).
          Page enforces client-side RBAC: super_admin_root, platform_admin,
          admin, super_admin, executive, ops. Patient/family/caregiver/partner
          roles are explicitly blocked. Also wrapped by the ORACLE acknowledgement
          gate (scope="adminone") so operators acknowledge once. */}
      <Route path="/admin/enterprise-telemetry" element={<AdminProtectedRoute><ConstitutionalGateOrchestrator scope="adminone"><AdminOneEnterpriseTelemetry /></ConstitutionalGateOrchestrator></AdminProtectedRoute>} />
      <Route path="/adminone/telemetry"         element={<AdminProtectedRoute><ConstitutionalGateOrchestrator scope="adminone"><AdminOneEnterpriseTelemetry /></ConstitutionalGateOrchestrator></AdminProtectedRoute>} />
      <Route path="/admin/hardening"            element={<AdminProtectedRoute><ConstitutionalGateOrchestrator scope="adminone"><AdminOneEnterpriseTelemetry /></ConstitutionalGateOrchestrator></AdminProtectedRoute>} />
      <Route path="/adminone/executive-intelligence" element={<AdminProtectedRoute><ConstitutionalGateOrchestrator scope="adminone"><AdminOneExecutiveIntelligence /></ConstitutionalGateOrchestrator></AdminProtectedRoute>} />
      <Route path="/oracle/lifecommand"               element={<ConstitutionalGateOrchestrator scope="oracle"><OracleLifeCommand /></ConstitutionalGateOrchestrator>} />
      {/* Final Daily Habit Intelligence Build Pack — additive (gated by ORACLE constitutional sequence) */}
      <Route path="/oracle/lifescore"                  element={<ConstitutionalGateOrchestrator scope="oracle"><OracleLifeScorePage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/wearables"                  element={<ConstitutionalGateOrchestrator scope="oracle"><OracleWearablesPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/animations"                 element={<ConstitutionalGateOrchestrator scope="oracle"><OracleAnimationsPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx"                    element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx/ceo-routine"        element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx/meal-plan"          element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx/interactions"       element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx/reminders"          element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/foodrx/reports"            element={<ConstitutionalGateOrchestrator scope="oracle"><OracleFoodRxPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/lifecommand"                      element={<ConstitutionalGateOrchestrator scope="oracle"><OracleLifeCommand /></ConstitutionalGateOrchestrator>} />
      {/* Domain Lock — canonical ORACLE routes (additive aliases mapped to existing pages) */}
      <Route path="/oracle"                element={<Navigate to="/" replace />} />
      <Route path="/oracle/market"         element={<Navigate to="/" replace />} />
      <Route path="/oracle/health"         element={<Navigate to="/oracle/lifecommand" replace />} />
      <Route path="/oracle/grants"         element={<Navigate to="/adminone/executive-intelligence" replace />} />
      <Route path="/oracle/contracts"      element={<Navigate to="/adminone/executive-intelligence" replace />} />
      <Route path="/oracle/research"       element={<Navigate to="/adminone/executive-intelligence" replace />} />
      <Route path="/oracle/governance"     element={<Navigate to="/adminone/telemetry" replace />} />
      <Route path="/oracle/briefings"      element={<ConstitutionalGateOrchestrator><OracleBriefingCenterPage /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/ai-agent-business" element={<ConstitutionalGateOrchestrator><OracleAIBusinessPage /></ConstitutionalGateOrchestrator>} />
      {/* legacy redirect kept under a different path so AdminOne-only briefing
          tooling still mounts but never preempts the member surface. */}
      <Route path="/oracle/briefings-admin" element={<Navigate to="/adminone/briefing-center" replace />} />
      <Route path="/logix2"                element={<Navigate to="/?logix2=open" replace />} />
      <Route path="/logix2/voice"          element={<Navigate to="/?logix2=open" replace />} />
      <Route path="/logix2/image"          element={<Navigate to="/?logix2=open" replace />} />
      <Route path="/logix2/health"         element={<Navigate to="/oracle/lifecommand" replace />} />
      <Route path="/logix2/research"       element={<Navigate to="/adminone/executive-intelligence" replace />} />
      <Route path="/adminone/briefing"     element={<Navigate to="/adminone/briefing-center" replace />} />
      <Route path="/adminone/ceo-command"  element={<Navigate to="/adminone/dashboard" replace />} />
      <Route path="/adminone/governance"   element={<Navigate to="/adminone/telemetry" replace />} />
      <Route path="/adminone/compliance"   element={<Navigate to="/adminone/telemetry" replace />} />
      <Route path="/adminone/capital"      element={<Navigate to="/oracle/capital" replace />} />
      <Route path="/adminone/health"       element={<Navigate to="/adminone/executive-intelligence" replace />} />


      <Route path="/oracle/funding"    element={<ConstitutionalGateOrchestrator><OracleFundingCommand    /></ConstitutionalGateOrchestrator>} />
      {/* ORACLE Global Capital Command™ — 16th constitutional domain (additive) */}
      <Route path="/oracle/capital"    element={<ConstitutionalGateOrchestrator><OracleGlobalCapitalCommand /></ConstitutionalGateOrchestrator>} />
      {/* Phase 36 — Global Intelligence Globe™ (2D, data-driven; additive) */}
      <Route path="/intelligence-globe" element={<ConstitutionalGateOrchestrator><IntelligenceGlobe /></ConstitutionalGateOrchestrator>} />
      <Route path="/oracle/globe"       element={<ConstitutionalGateOrchestrator><IntelligenceGlobe /></ConstitutionalGateOrchestrator>} />


      {/* Phase 23 — Public member access screen (additive) */}
      <Route path="/access" element={<AccessLogin />} />
      <Route path="/login"  element={<AccessLogin />} />

      {/* AdminOne (separate auth scope) — also requires the ORACLE acknowledgement gate (scope="adminone").
          The /adminone/login route below is intentionally NOT gated so operators can sign in. */}
      <Route path="/adminone" element={<AdminProtectedRoute><ConstitutionalGateOrchestrator scope="adminone"><AdminOneLayout /></ConstitutionalGateOrchestrator></AdminProtectedRoute>}>
        <Route index element={<AdminOneDashboard />} />
        <Route path="dashboard" element={<AdminOneDashboard />} />
        <Route path="ops" element={<AdminOps />} />
        <Route path="signals" element={<AdminSignals />} />
        <Route path="watchtowers" element={<AdminWatchtowers />} />
        <Route path="services" element={<AdminServiceIntelligence />} />
        <Route path="healthcare-map" element={<AdminHealthcareMap />} />
        <Route path="membership" element={<AdminMembership />} />
        <Route path="membership-analytics" element={<AdminMembershipAnalytics />} />
        <Route path="telemetry" element={<AdminTelemetry />} />
        <Route path="rate-limits" element={<AdminRateLimits />} />
        <Route path="orgs" element={<AdminOrgs />} />
        <Route path="ingestion" element={<AdminIngestion />} />
        <Route path="logix2" element={<AdminLogix2 />} />
        <Route path="opportunity-radar" element={<AdminOpportunityRadar />} />
        <Route path="diagnostics" element={<AdminDiagnostics />} />
        <Route path="chyron" element={<AdminChyronManager />} />
        <Route path="africa" element={<AdminAfricaWatchtower />} />
        <Route path="global-ai" element={<AdminGlobalAIWatchtower />} />
        <Route path="uganda-phase2" element={<UgandaPhase2ActivationCommand />} />
        <Route path="network/uganda-phase2" element={<UgandaPhase2ActivationCommand />} />
        <Route path="intelligence" element={<AdminOracleIntelligenceDashboard />} />
        <Route path="intelligence-dashboard" element={<AdminOracleIntelligenceDashboard />} />
        <Route path="startups-grants" element={<AdminStartupsGrants />} />
        <Route path="briefing-center" element={<AdminBriefingCenter />} />
        <Route path="oracle-watchtowers" element={<OracleWatchtowers />} />
        <Route path="signal-command" element={<OracleSignalCommand />} />
        <Route path="scanner-command" element={<AdminScannerCommand />} />
        <Route path="notification-fabric" element={<AdminNotificationFabric />} />
        <Route path="oracle-feed" element={<AdminOracleFeed />} />
        <Route path="oanda" element={<AdminOandaCenter />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="compliance" element={<AdminCompliance />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="sessions" element={<AdminSessions />} />
        <Route path="settings" element={<AdminSettings />} />
        {/* Phase 33 — AdminOne Phase 33 routes (additive) */}
        <Route path="funding-intelligence"    element={<AdminFundingIntelligence />} />
        <Route path="market-abuse-awareness"  element={<AdminMarketAbuseAwareness />} />
        <Route path="system-architecture"     element={<AdminSystemArchitecture />} />
        {/* AdminOne CEO Travel Command™ (additive) */}
        <Route path="ceo-travel-command"      element={<AdminOneCEOTravelCommand />} />
        {/* CareLogix™ Global Integration Connector Pack v1 — AdminOne only */}
        <Route path="connectors"              element={<AdminOneConnectorStatusPage />} />
        <Route path="ehr-ingestion"           element={<AdminOneEHRIngestionPage />} />
        <Route path="africa-health"           element={<AdminOneAfricaHealthNodesPage />} />
        <Route path="mobility-dispatch"       element={<AdminOneMobilityDispatchPage />} />
        <Route path="payout-ledger"           element={<AdminOnePayoutLedgerPage />} />
        <Route path="foodrx-intelligence"     element={<AdminOneFoodRxIntelligence />} />
        {/* Final Daily Habit Intelligence Build Pack — AdminOne aggregate dashboard */}
        <Route path="lifecommand"             element={<AdminOneLifeCommand />} />
        {/* AdminOne CEO Membership Control™ — additive */}
        <Route path="membership-control"      element={<AdminOneMembershipDashboard />} />
        {/* ORACLE Live Data Control Center™ — additive */}
        <Route path="live-data"               element={<AdminOneLiveDataCenter />} />
        {/* ORACLE Live LLM Engine™ — additive (Live Operations Upgrade Phase 2) */}
        <Route path="live-llm"                element={<AdminOneLiveLLMEngine />} />
        {/* AdminOne Content Generator™ — internal media repurposing (AdminOne-only) */}
        <Route path="content-generator"       element={<AdminOneContentGenerator />} />
        {/* Phase 37 — AdminOne Grants/Funding Inbox (CEO-only) */}
        <Route path="inbox"                   element={<AdminOneInboxPage />} />
        {/* Phase 38 — Core-Satellite Intelligence Dashboard (CEO-only) */}
        <Route path="core-satellite"          element={<AdminOneCoreSatellitePage />} />
        {/* Simplicity Release v2.0 — AdminOne System Readiness (CEO-only) */}
        <Route path="system-readiness"        element={<AdminOneSystemReadinessPage />} />
        <Route path="logix2-health"           element={<AdminOneLogix2HealthPage />} />
        <Route path="ceo-dashboard"           element={<AdminOneCEODashboardPage />} />
        <Route path="ai-business-command"     element={<AdminOneAIBusinessCommandPage />} />
      </Route>
      <Route path="/adminone/login" element={<AdminOneLogin />} />

      {/* Fallback to ORACLE app — also gated by Phase 32.2 Constitutional 3-gate sequence */}
      <Route path="*" element={<ConstitutionalGateOrchestrator><Oracle /></ConstitutionalGateOrchestrator>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MembershipProvider>
          <PersonalizationProvider>
            <AnimationSettingsProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </AnimationSettingsProvider>
          </PersonalizationProvider>
        </MembershipProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
